import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthCallback } from '../../store/actions/auth.action';

/**
 * Composant qui sert de page de retour de l'authentification et qui complète l'authentification.
 */
@Component({
    selector: 'lib-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  store = inject(Store<any>);

  ngOnInit() {
    this.store.dispatch(new AuthCallback());
  }
}
